import { render, staticRenderFns } from "./LamboDigital.vue?vue&type=template&id=247c88ad&"
import script from "./LamboDigital.vue?vue&type=script&lang=js&"
export * from "./LamboDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports